import { render } from "./LinkTo.vue?vue&type=template&id=e947582c&scoped=true"
import script from "./LinkTo.vue?vue&type=script&lang=js"
export * from "./LinkTo.vue?vue&type=script&lang=js"

import "./LinkTo.vue?vue&type=style&index=0&id=e947582c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e947582c"]])

export default __exports__